import React from 'react';

interface SVGRoundedLogoProps {
  passName: string;
  pass: string;
  className?: string;
}

export default function SVGRoundedLogo({ passName, pass, className }: SVGRoundedLogoProps): JSX.Element {
  return (
    <svg
      width="190"
      height="190"
      viewBox="0 0 190 190"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="95" cy="95" r="95" fill="url(#paint0_linear_5646:214779)" />
      <text
        fill="white"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Aventa"
        fontSize="32"
        fontWeight="600"
        letterSpacing="-0.165px"
        alignmentBaseline="middle"
        textAnchor="middle"
      >
        <tspan x="50%" y="90.6364">
          {passName}&#10;
        </tspan>
        <tspan x="50%" y="124.636">
          {pass}
        </tspan>
      </text>
      <defs>
        <linearGradient
          id="paint0_linear_5646:214779"
          x1="50%"
          y1="100%"
          x2="50%"
          y2="21%"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6B4E" />
          <stop offset="1" stopColor="#FFA877" />
        </linearGradient>
      </defs>
    </svg>
  );
}

SVGRoundedLogo.defaultProps = {
  className: 'rounded-logo',
};
